import React, { memo, useCallback } from 'react';
import { AddIcon } from 'reactApp/ui/VKUIIcons';

import styles from './CreateAlbum.css';

interface IProps {
    onClick?(): void;
}

export const CreateAlbum = memo(function CreateAlbum({ onClick }: IProps) {
    const createAlbumHandler = useCallback(() => {
        onClick?.();
    }, [onClick]);

    return (
        <div className={styles.root} onClick={createAlbumHandler} data-qa-id="create-album">
            <div className={styles.addIcon}>
                <AddIcon className={styles.add} />
            </div>
            Создать альбом
        </div>
    );
});
